import type { AppIconProps } from "../IconTypes";

export const FolderOpenIcon: React.FC<AppIconProps> = ({
  width = 16,
  height = 16,
  className,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.50012 5.25C1.50012 4.65326 1.73717 4.08097 2.15913 3.65901C2.58108 3.23705 3.15338 3 3.75012 3H7.89612C9.33312 3 10.5361 3.84 11.3626 4.776C11.9776 5.472 12.7201 6 13.5001 6H20.2501C20.8469 6 21.4192 6.23705 21.8411 6.65901C22.2631 7.08097 22.5001 7.65326 22.5001 8.25V9.21C23.3551 9.6075 23.9101 10.524 23.7841 11.529L22.8241 19.215C22.7107 20.1226 22.2695 20.9574 21.5836 21.5624C20.8976 22.1674 20.0142 22.5008 19.0996 22.5H4.89912C3.98501 22.5001 3.10234 22.1663 2.41703 21.5614C1.73172 20.9565 1.29097 20.1221 1.17762 19.215L0.217617 11.529C0.158476 11.0565 0.250781 10.5774 0.481245 10.1607C0.711709 9.74394 1.06845 9.41108 1.50012 9.21V5.25ZM3.00012 9H21.0001V8.25C21.0001 8.05109 20.9211 7.86032 20.7804 7.71967C20.6398 7.57902 20.449 7.5 20.2501 7.5H13.5001C12.0541 7.5 10.9351 6.5565 10.2391 5.769C9.56112 5.001 8.73012 4.5 7.89612 4.5H3.75012C3.5512 4.5 3.36044 4.57902 3.21979 4.71967C3.07913 4.86032 3.00012 5.05109 3.00012 5.25V9ZM2.44962 10.5C2.34329 10.5 2.23819 10.5227 2.14128 10.5664C2.04437 10.6102 1.95786 10.674 1.88751 10.7537C1.81715 10.8334 1.76455 10.9272 1.73319 11.0288C1.70183 11.1304 1.69243 11.2375 1.70562 11.343L2.66562 19.029C2.73364 19.5733 2.99818 20.0741 3.40949 20.437C3.8208 20.8 4.35055 21.0002 4.89912 21H19.1011C19.6497 21.0002 20.1794 20.8 20.5907 20.437C21.0021 20.0741 21.2666 19.5733 21.3346 19.029L22.2946 11.343C22.3078 11.2375 22.2984 11.1304 22.267 11.0288C22.2357 10.9272 22.1831 10.8334 22.1127 10.7537C22.0424 10.674 21.9559 10.6102 21.859 10.5664C21.762 10.5227 21.6569 10.5 21.5506 10.5H2.44962Z"
        fill="#7A909C"
      />
    </svg>
  );
};
